<a
  *ngIf="cignaTrackClicks; else noTracking"
  [routerLink]="routerLink"
  [queryParams]="queryParams"
  [fragment]="fragment"
  [cignaTrackClicks]="cignaTrackClicks"
  [target]="target"
  ><ng-template [ngTemplateOutlet]="content"></ng-template
></a>
<ng-template #noTracking>
  <a
    [routerLink]="routerLink"
    [queryParams]="queryParams"
    [fragment]="fragment"
    [target]="target"
  >
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </a>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
